import { useState } from "react"
import { useIntl } from "react-intl"

import { ICONS } from "@doktor-se/bones-ui"
import { IconButton } from "@doktor-se/bones-ui/dist/web-shared/components"

import { handleFlagged } from "api/error/handler"
import { useSelectedConversationAmplitudeLogger } from "lib/amplitude/hooks"
import { useAppDispatch } from "lib/hooks"

import ActionPill from "components/topmenu/ReportBug/ActionPill/ActionPill"

import ConfirmReportSent from "./ConfirmReportSent"
import ReportBugDialog from "./ReportBugDialog"

import styles from "./ReportBug.module.scss"

interface ReportBugProps {
  conversationId?: string
  buttonType: "pill" | "icon"
}

const ReportBug = ({ conversationId, buttonType = "pill" }: ReportBugProps) => {
  const intl = useIntl()
  const dispatch = useAppDispatch()
  const [showFlagModal, setShowFlagModal] = useState(false)
  const [showFlagSentModal, setShowFlagSentModal] = useState(false)
  const logEvent = useSelectedConversationAmplitudeLogger()
  const onClick = () => {
    if (buttonType === "icon") {
      logEvent("conversation.technical_issues.pressed")
    }
    setShowFlagModal(true)
  }

  return (
    <>
      {buttonType === "pill" && (
        <div className={styles.actions}>
          <ActionPill
            Icon={ICONS.Flag}
            text={intl.formatMessage({ id: "flag.report.button" })}
            onClick={onClick}
            colored
          />
        </div>
      )}
      {buttonType === "icon" && (
        <div className={styles.iconButton}>
          <IconButton
            iconSize={20}
            labelSize={14}
            onClick={onClick}
            Icon={ICONS.Flag}
            label={intl.formatMessage({ id: "label.errand.reportIssue" })}
          />
        </div>
      )}
      <ReportBugDialog
        isOpen={showFlagModal}
        onClose={() => setShowFlagModal(false)}
        flag={(flagBody, flagSubject) => {
          dispatch(handleFlagged(flagBody, flagSubject, conversationId))
          setShowFlagModal(false)
          setShowFlagSentModal(true)
        }}
      />
      <ConfirmReportSent isOpen={showFlagSentModal} onClose={() => setShowFlagSentModal(false)} />
    </>
  )
}

export default ReportBug
